import { Navigate } from 'react-router-dom';
import { IRoute, PortalRoutePath } from '@models';
import { Tr } from '@utils';
import { Permission } from '@services';
import { Location } from './Location';
import { GlobeIcon } from '@components/icons';
import { AddParkingArea } from './AddParkingArea';
import { EditParkingArea } from './EditParkingArea';
import { EditAssesment } from './EditAssesment';
import { LocationInfrastructureOverview } from './LocationInfrastructureOverview';
import { ParkingAreaInfrastructureSizingUserInput } from './ParkingAreaInfrastructureSizingUserInput';

export const LOCATION_ROUTES: IRoute = {
	path: PortalRoutePath.LOCATION,
	icon: <GlobeIcon />,
	text: <Tr.Portal path="location.title" />,
	canActivate: (_route, user) => !!user?.hasPermission([Permission.SITE_READ, Permission.SITE_WRITE]) && !user?.isDriver(),
	children: [
		{
			path: '',
			element: <Location />
		},
		{
			path: 'parking-area/add',
			hideFromMenu: true,
			element: <AddParkingArea />
		},
		{
			path: ':siteId/parking-area/:parkAreaId/edit',
			hideFromMenu: true,
			element: <EditParkingArea />
		},
		{
			path: ':siteId/parking-area/:parkAreaId/assesment/:assesmentId/edit',
			hideFromMenu: true,
			element: <EditAssesment />
		},
		{
			path: ':siteId/infrastructure/:simulationId',
			hideFromMenu: true,
			element: <LocationInfrastructureOverview />
		},
		{
			path: ':siteId/infrastructure/:simulationId/parking-area/:parkAreaId',
			hideFromMenu: true,
			element: <ParkingAreaInfrastructureSizingUserInput />
		},
		{
			index: true,
			path: '*',
			hideFromMenu: true,
			element: <Navigate to={{ pathname: '..' }} replace />
		}
	]
};
